import Router, {Consent, Nav} from "skeleton-router";

const doc = document;
const body = doc.body

const router = new Router();
const nav = new Nav();
const consent = new Consent({
    modules: [
        {
            categories: ['analytics'],
            load: () => {
                (function (w, d, s, l, i) {
                    w[l] = w[l] || [];
                    w[l].push({
                        'gtm.start':
                            new Date().getTime(), event: 'gtm.js'
                    });
                    const f = d.getElementsByTagName(s)[0],
                        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
                    j.async = true;
                    j.src =
                        'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                    f.parentNode.insertBefore(j, f);
                })(window, document, 'script', 'dataLayer', trackingId);
            }
        }
    ],
});

const langLinks = doc.querySelectorAll('.lang-link');

const hasMenuClass = 'has-menu';

const addClass = (element, className) => element.classList.add(className);
const removeClass = (element, className) => element && element.classList.remove(className);

const addScript = (src) => {
    const script = 'script';
    const $parent = doc.getElementsByTagName(script)[0];
    const $el = doc.createElement(script);

    $el.async = true;
    $el.src = src
    $parent.parentNode.insertBefore($el, $parent);
}

let yPos = 0;

// Menu button.
doc.querySelectorAll('.menu-toggle').forEach((item) => {
    item.addEventListener('click', () => {
        const isMobile = window.innerWidth < 1024;

        if (body.classList.contains(hasMenuClass)) {
            removeClass(body, hasMenuClass);

            if (isMobile) {
                window.scrollTo(0, yPos)
            }
        } else {
            if (isMobile) {
                yPos = window.scrollY;
                window.scrollTo(0, 0);
            }

            addClass(body, hasMenuClass);
        }
    });
});

router.onUnhandledClick = () => removeClass(body, hasMenuClass);

router.afterRender = () => {
    const pathname = location.pathname;
    const host = `${location.protocol}//${location.hostname}`;

    const resetVideo = () => {
        if (currentVideo) {
            currentVideo.parentElement.classList.remove('has-video');
            currentVideo.src = '';
            currentVideo.style.display = 'none';
        }
    }

    let currentVideo;

    // Consent
    consent.initButtons();

    // Language
    langLinks.forEach((link) => {
        const href = document.documentElement.lang === 'de' ? pathname.substring(3) : pathname;
        link.href = `${host}${link.dataset.prefix}${href}`.replace(/\/$/, '');
    });

    // Swiper
    const $sliders = router.main.querySelectorAll('.swiper');

    if ($sliders.length) {
        import('./swiper.js').then((module) => {
            module.default($sliders, resetVideo);
        });
    }

    // Videos.
    router.main.querySelectorAll('.video').forEach((btn) => {
        btn.addEventListener('click', () => {
            resetVideo();

            currentVideo = btn.nextElementSibling;
            currentVideo.parentElement.classList.add('has-video');
            currentVideo.src = btn.dataset.iframeSrc;
            currentVideo.style.display = 'block';
        });
    });

    body.className = '';
    nav.update();
}

router.afterRender();